import { ChangeDetectionStrategy, Component, computed, input, model } from '@angular/core';
import { PcButtonIcon } from '@pc/common';
import { IconComponent } from '@pc/icon';
import { ResponsiveAbstractCardComponent } from '@pc/responsive-abstract-card';
import { ChevronState, OverviewState } from '../../../components/quote-overview/quote-overview.const';
import { ItemsSummaryCardAnimation } from '@pc/items-summary-card';
import { expand } from '@pc/animations';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'pc-summary-collapsible-card',
  standalone: true,
  imports: [IconComponent, ResponsiveAbstractCardComponent, TranslateModule],
  templateUrl: './summary-collapsible-card.component.html',
  styleUrl: './summary-collapsible-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [ItemsSummaryCardAnimation, expand]
})
export class SummaryCollapsibleCardComponent {
  public title = input.required<string>();
  public footer = input<string>('');
  public isSuccessOverviewOpen = model<boolean>(true);
  public chevronState = computed(() => this.getChevronState());
  public quoteOverviewState = computed(() => this.getQuoteOverviewState());
  protected readonly PcButtonIcon = PcButtonIcon;

  public changeOverviewMode(): void {
    this.isSuccessOverviewOpen.set(!this.isSuccessOverviewOpen());
  }

  private getChevronState(): ChevronState {
    return this.isSuccessOverviewOpen() ? ChevronState.Rotated : ChevronState.Default;
  }

  private getQuoteOverviewState(): OverviewState {
    return this.isSuccessOverviewOpen() ? OverviewState.Expanded : OverviewState.Collapsed;
  }
}
